import { VideoCamera } from '@phosphor-icons/react';

export default VideoCamera;
